import { IExchangeToken, Resource } from '@notes/webintegrations-common'
import { IGetToken } from './IGetToken'

export class O365GetToken implements IGetToken {
  exchangeToken: IExchangeToken
  accessToken: string
  tenantId: string

  constructor(exchangeToken: IExchangeToken, accessToken: string, tenantId: string) {
    this.exchangeToken = exchangeToken
    this.accessToken = accessToken
    this.tenantId = tenantId
  }

  async getSubstrateNotesToken(): Promise<string> {
    const exchangeTokenInfo = await this.exchangeToken.exchangeToken(this.accessToken, this.tenantId!, Resource.OutlookO365)
    return exchangeTokenInfo.accessToken
  }

  async getGraphUserInfoToken(): Promise<string> {
    return await this.getGraphToken()
  }

  async getOneNoteUserInfoToken(): Promise<string> {
    const exchangeTokenInfo = await this.exchangeToken.exchangeToken(this.accessToken, this.tenantId!, Resource.OneNote)
    return exchangeTokenInfo.accessToken
  }

  private async getGraphToken(): Promise<string> {
    const exchangeTokenInfo = await this.exchangeToken.exchangeToken(this.accessToken, this.tenantId!, Resource.GraphNotes)
    return exchangeTokenInfo.accessToken
  }
}
